"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var FilterCheckbox_1 = __importDefault(require("./FilterCheckbox"));
var styles_1 = __importDefault(require("../../styles"));
exports.default = (function (_a) {
    var isIncludeFiles = _a.isIncludeFiles, isIncludeLinks = _a.isIncludeLinks, isIncludeActive = _a.isIncludeActive, isIncludeInactive = _a.isIncludeInactive, _b = _a.hideStatus, hideStatus = _b === void 0 ? false : _b, setIsIncludeFiles = _a.setIsIncludeFiles, setIsIncludeLinks = _a.setIsIncludeLinks, setIsIncludeActive = _a.setIsIncludeActive, setIsIncludeInactive = _a.setIsIncludeInactive;
    var _c = __read(react_i18next_1.useTranslation(), 1), t = _c[0];
    var classes = styles_1.default();
    var theme = core_1.useTheme();
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    // const domains = ['None', 'mptc', 'dgc']
    // const handleChange = (event: any) => {
    //   if (event.target.value === 'None') setDomain('')
    //   else setDomain(event.target.value)
    // }
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, direction: "column" },
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.filterHeaderGrid },
            react_1.default.createElement(core_1.Typography, { variant: isMobile ? 'h3' : 'caption', className: classes.sectionHeader }, isMobile ? t('filterBy.titleMobile') : t('filterBy.title'))),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.dividerGrid },
            react_1.default.createElement(core_1.Divider, { className: classes.divider })),
        react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column", className: classes.filterSectionGrid },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.filterSectionHeader }, t('filterBy.destination.header'))),
            react_1.default.createElement(core_1.Grid, { container: true, item: true, alignItems: "center" },
                react_1.default.createElement(FilterCheckbox_1.default, { checked: isIncludeLinks, className: classes.leftCheckbox, onClick: function () { return setIsIncludeLinks(!isIncludeLinks); } }),
                react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.filterLabelLeft }, t('filterBy.destination.body1')),
                react_1.default.createElement(FilterCheckbox_1.default, { checked: isIncludeFiles, className: classes.leftCheckbox, onClick: function () { return setIsIncludeFiles(!isIncludeFiles); } }),
                react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.filterLabelRight }, t('filterBy.destination.body2')))),
        !hideStatus && (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column", className: classes.filterSectionGrid },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.filterSectionHeader }, t('filterBy.status.header'))),
            react_1.default.createElement(core_1.Grid, { container: true, item: true, alignItems: "center" },
                react_1.default.createElement(FilterCheckbox_1.default, { checked: isIncludeActive, className: classes.leftCheckbox, onClick: function () { return setIsIncludeActive(!isIncludeActive); } }),
                react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.filterLabelLeft }, t('filterBy.status.body1')),
                react_1.default.createElement(FilterCheckbox_1.default, { checked: isIncludeInactive, className: classes.leftCheckbox, onClick: function () { return setIsIncludeInactive(!isIncludeInactive); } }),
                react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.filterLabelRight }, t('filterBy.status.body2')))))));
});
